import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/schedly/calcom/apps/web/app/(use-page-wrapper)/(main-nav)/availability/skeleton.tsx");
